
export const updateInteractionsOpenAction = (id: string) => {
  return {
    type: 'UPDATE_INTERACTIONS_OPEN',
    data: id,
  };
};
